import { T } from '../../styles/theme'

export default function StatTile({ value, label, delta, deltaUnit }) {
  return (
    <div style={{ background: T.card, border: `1px solid ${T.cardB}`, borderRadius: 14, padding: 14 }}>
      <div style={{ fontSize: 20, fontWeight: 700, fontFamily: 'DM Mono, monospace' }}>{value}</div>
      <div style={{ fontSize: 11, color: T.muted, marginTop: 3 }}>{label}</div>
      {delta != null && (
        <div style={{ fontSize: 12, fontWeight: 600, marginTop: 4, color: delta <= 0 ? T.accent : T.danger }}>
          {delta > 0 ? '+' : ''}{delta} {deltaUnit}
        </div>
      )}
    </div>
  )
}
